import { Injectable } from '@angular/core';
// @ts-ignore
import * as users_data from '../data/users.json';

@Injectable()
export class LocalDataService {
  static users(): any[] {
    const users = (users_data as any).default;
    return users;
  }
}
